import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_7356",
	"data-name": "Group 7356",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3861",
				"data-name": "Rectangle 3861",
				width: 16,
				height: 16
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_7355",
			"data-name": "Group 7355",
			clipPath: "url(#clip-path)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_19292",
				"data-name": "Path 19292",
				d: "M3.147,1.778a10.944,10.944,0,0,0,.4,2.3L2.48,5.147A13.178,13.178,0,0,1,1.8,1.778Zm8.764,10.684a11.336,11.336,0,0,0,2.311.4v1.324a13.712,13.712,0,0,1-3.378-.667l1.067-1.058M4,0H.889A.892.892,0,0,0,0,.889,15.11,15.11,0,0,0,15.111,16,.892.892,0,0,0,16,15.111v-3.1a.892.892,0,0,0-.889-.889,10.14,10.14,0,0,1-3.173-.507.746.746,0,0,0-.276-.044.911.911,0,0,0-.631.258L9.076,12.782A13.465,13.465,0,0,1,3.218,6.924L5.173,4.969A.892.892,0,0,0,5.4,4.062,10.1,10.1,0,0,1,4.889.889.892.892,0,0,0,4,0"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
